module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"regionsTable.noRegions":"There are no regions visible in this tenant.","regionsTable.currentMonth.title":"Last 30 days","regionsTable.providerType.title":"Provider","regionsTable.geography.title":"Geography","regionsTable.search.placeholder":"Search regions by name, provider etc.","regionsTable.search.title":"Search within results..."}}')
  delete Component.options._Ctor
}
